import React from 'react';
import { FaDownload, FaUserPlus, FaSearch, FaCheckCircle } from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaDownload />,
      title: 'Download App',
      description: 'Get JobFinder from the App Store or Google Play. Free to download and use.'
    },
    {
      icon: <FaUserPlus />,
      title: 'Create Account',
      description: 'Sign up as a job seeker or company. It takes less than 2 minutes.'
    },
    {
      icon: <FaSearch />,
      title: 'Browse & Apply',
      description: 'Search for jobs using advanced filters. Apply with one tap directly from your phone.'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Get Hired',
      description: 'Connect with employers and start your new career journey.'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works-container">
        <div className="section-header">
          <h2 className="section-title">Getting Started with the App</h2>
          <p className="section-description">
            Your journey to a new job starts on your phone. Follow these simple steps.
          </p>
        </div>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-number">{index + 1}</div>
              <div className="step-content">
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;

